<ng-container *ngIf="program$ | async as program; else loading">
  <rk-program-details-header [program]="program"></rk-program-details-header>
  <ng-container *ngIf="program.playlistsNumber > 0; else empty">
    <rk-program-details-list [program]="program"></rk-program-details-list>
  </ng-container>
</ng-container>

<ng-template #loading>
  <div>
    <rk-loader [isLoading]="true" [size]="60" [center]="true"></rk-loader>
  </div>
</ng-template>

<ng-template #empty>
  <div class="program-empty">
    <img src="/assets/playlist-empty.svg" />
    <div *ngIf="hasPlaylists$ | async; else createPlaylistMessage" translate>
      SCHEDULE.PROGRAMS.PROGRAM_EMPTY
    </div>
    <ng-template #createPlaylistMessage>
      <div translate>SCHEDULE.PROGRAMS.NO_PLAYLIST_PLEASE_CREATE</div>
    </ng-template>
    <rk-button
      class="md:block hidden"
      *ngIf="hasPlaylists$ | async; else createPlaylistButton"
      [label]="'SCHEDULE.PROGRAMS.ADD_PLAYLIST' | translate"
      [faIcon]="'fa-plus'"
      (click)="addPlaylist()"
    ></rk-button>
    <ng-template #createPlaylistButton>
      <rk-button
        class="md:block hidden"
        [label]="'SCHEDULE.PROGRAMS.GO_TO_LIBRARY' | translate"
        [faIcon]="'fa-plus'"
        (click)="navigateToLibrary()"
      ></rk-button>
    </ng-template>
  </div>
</ng-template>
